import { useQuery } from '@tanstack/react-query';

import { getPromoMigrations } from '~/services/PromoService';

export const promoMigrationQueryKeys = {
  all: ['promo-migrations'] as const,
  latest: () => [...promoMigrationQueryKeys.all, 'latest'] as const,
};

export function useGetPromoMigrations({ enabled = false }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: promoMigrationQueryKeys.latest(),
    queryFn: ({ signal }) => getPromoMigrations({ signal }),
    enabled,
  });
}
